import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../Config/Base";
import _ from "lodash";
import { ToastContainer, toast } from "react-toastify";

/*----function with pagination----*/

const pageSize = 3;

const SaventuresMain = () => {
  const [file, setFile] = useState();
  const [fileA, setFileA] = useState();
  console.log(file);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setFileA(e.target.value)

    document.getElementById("sachangeinput").reset()
  };

  const [EditParoSection, SetEditParoSection] = useState([]);

  // GET request using fetch()

  const token = JSON.parse(localStorage.getItem("usertoken"));
  const [allVentures, setAllusers] = useState([]);
  const [allusers, setAllUsers] = useState([]);

  const [paginatedPosts, setpaginatedPosts] = useState(0);
  const [currentPage, setcurrentPage] = useState(1);

  useEffect(() => {
    GetVenture();
    Getusers();
  }, []);

  function GetVenture() {
    console.log("Token", token);
    fetch(`https://localhost:44312/api/Venture/GetVentures`, {
      method: "GET",

      headers: {
        "Content-type": "application/json",

        Accept: "application/json",

        Authorization: "Bearer " + `${token}`,

        "Access-Control-Allow-Headers": "Access-Control-Request-Headers ",
      },

      //body:JSON.stringify(data)
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Data", data);
        setAllusers(data);
        setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        
      });

    console.log("check", allVentures);
  }

  const pageCount = allVentures ? Math.ceil(allVentures.length / pageSize) : 0;
  const pages = _.range(1, pageCount + 1);
  const pagination = (pageNo) => {
    setcurrentPage(pageNo);
    const startIndex = (pageNo - 1) * pageSize;
    const paginatedPost = _(allVentures)
      .slice(startIndex)
      .take(pageSize)
      .value();
    setpaginatedPosts(paginatedPost);
  };

  function Paropcloseform() {
    window.location.reload();
    document.getElementById("modalRegisterForm").style.display = "none";
  }

  /*---fetch add Venture----*/

  function fetchSaventuredata() {
    var input = document.getElementById("VentureName").value;
    // var image = document.getElementById('file-input').value;
    var inputA = document.getElementById("VentureId").value;

    const body = {
      VentureName: input,
      VentureLogo: file,
      VentureId1: inputA,
      DeleteStatus:0

    };
    console.log(body);

    let bearer = "Bearer " + JSON.parse(localStorage.getItem("usertoken"));

    axios({
      method: "POST",
      url: `${BASE_URL}/Venture/AddVenture`,
      data: body,
      headers: {
        "Content-Type": "multipart/form-data",

        Authorization: bearer,
      },
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.status === "Already Exist") {
          
          alert("Id or UserName Already Exist");
        } else if (response.data.status === "Success") {
          //  toast.success("Venture Added Successfully!", {
          //    position: "top-center",
          //    autoClose: 3200,
          //    hideProgressBar: false,
          //    closeOnClick: true,
          //    pauseOnHover: true,
          //    draggable: true,
          //    progress: undefined,
          //    className: 'toast-message'
          //    });
          alert("Venture Added Successfully!");
          //  setTimeout(() => {
          //  document.getElementById('Formreset').reset();
          Paropcloseform();

          //  }, 5000);
        }
      })

      .catch((error) => {
        console.log(error);
        alert("failed !");
      });
  }

  /*----Open & Close Edit and Add popup----*/

  function openEditform() {
    document.getElementById("DisplayEditPop").style.display = "block";
  }

  function closeEditForm() {
    document.getElementById("DisplayEditPop").style.display = "none";
    document.getElementById("Parosectionform").reset();
  }

  //-------------------------------------------

  /*----Get select to the particular Id----*/


  const [EditSaLink ,SetEditSaLink] =useState([]);
  const [OldLink ,SetOldLink] =useState([]);

  function selectVenture(Id) {

    setFileA();
    setFile();
    const token = JSON.parse(localStorage.getItem("usertoken"));
  
    document.getElementById("DisplayEditPop").style.display = "block";

    const body = {
      ventureId: Id,
    };
    console.log("body", body);

    axios({
      method: "POST",
      url: `${BASE_URL}/Venture/SelectVenture`,
      data: body,
      headers: {
        "Content-type": "application/json",
        Authorization: "Bearer " + `${token}`,
      },
    })
      .then((response) => {
        console.log(response.data);

        SetEditParoSection(response.data);

        localStorage.setItem("SaventureLogo", JSON.stringify(response.data));
        let checkLink=JSON.parse(localStorage.getItem('SaventureLogo'));
        let Check =checkLink.map((item) => item.ventureLogo)
        let CheckA = Check[0]
        SetOldLink(CheckA)
            let CheckB= CheckA.slice(31);
            SetEditSaLink(CheckB)
            console.log("srdt",CheckB)



      })
      .catch((error) => {
        console.log(error);
      });
  }

  /*----function with validation----*/

  function handleSubmit(event) {
    event.preventDefault();

    //var Id = document.getElementById("VentureId").value;
    var Name = document.getElementById("VentureName").value;
    var Logo = document.getElementById("VentureLogo").value;
    var VentureId = document.getElementById("VentureId").value;

    //  if(!Id){

    //    document.getElementById("IdErr").innerHTML="Venture Id Required";

    //  }

    //  else{
    //    document.getElementById("IdErr").innerHTML=" ";

    //  }

    if (!Name) {
      document.getElementById("nameErr").innerHTML = "Venture Name Required ";
    } else if (Name.length < 3) {
      document.getElementById("nameErrA").innerHTML =
        "Enter Atleast 3 Characters";
      document.getElementById("nameErr").innerHTML = " ";
    } else {
      document.getElementById("nameErr").innerHTML = "  ";
      document.getElementById("nameErrA").innerHTML = "  ";
    }

    if (!Logo) {
      document.getElementById("nameErr1").innerHTML = "Venture Logo Required";
    } else {
      document.getElementById("nameErr1").innerHTML = "";
    }

    if (!VentureId) {
      document.getElementById("nameErri").innerHTML = "Venture Id Required";
    } else {
      document.getElementById("nameErrid").innerHTML = "";
    }
    if (Name.length >= 3 && Logo && VentureId) {
      fetchSaventuredata();
    }
  }

  /*---HandleChange function---*/

  function handlechange(event) {
    event.preventDefault();

    // var Id = document.getElementById("VentureId").value;

    var Name = document.getElementById("VentureName").value;
    var ventureId1 = document.getElementById("VentureId").value;

    //  if(!Id){

    //   document.getElementById("IdErr").innerHTML="Venture Id Required";

    // }

    // else{
    //   document.getElementById("IdErr").innerHTML=" ";

    // }

    if (!Name) {
      document.getElementById("nameErr").innerHTML = "Venture Name Required ";
      document.getElementById("nameErrA").innerHTML = "  ";
    } else if (Name.length < 3) {
      document.getElementById("nameErrA").innerHTML =
        "Enter Atleast 3 Characters";
      document.getElementById("nameErr").innerHTML = " ";
    } else {
      document.getElementById("nameErr").innerHTML = "  ";
      document.getElementById("nameErrA").innerHTML = "  ";
    }
    if (!ventureId1) {
      document.getElementById("nameErri").innerHTML = "Venture Id Required ";
      document.getElementById("nameErrid").innerHTML = "  ";
    } else if (ventureId1.length > 0) {
      document.getElementById("nameErri").innerHTML = "";
      document.getElementById("nameErrid").innerHTML = " ";
    } else {
      document.getElementById("nameErri").innerHTML = "  ";
      document.getElementById("nameErrid").innerHTML = "  ";
    }
  }

  /*----Function open form----*/

  function Saopenform() {
    document.getElementById("modalRegisterForm").style.display = "block";
  }

  /*----Function close form----*/

  function SaCloseform() {
    window.location.reload();

    document.getElementById("modalRegisterForm").style.display = "none";
  }

  /*----EditSection----*/

  function EditVenture(Id) {
    const token = JSON.parse(localStorage.getItem("usertoken"));

    var inputA = document.getElementById("ParotextA").value;
    var OldLogo =OldLink;

    if (!inputA) {
      document.getElementById("UpdateSecErrA").innerHTML =
        "SectionName Required";
    } else if (inputA) {
      document.getElementById("UpdateSecErrA").innerHTML = " ";
    }

    // if (!file) {
    //   document.getElementById("UpdateSecErrB").innerHTML = "Image Required";
    // } else if (file) {
    //   document.getElementById("UpdateSecErrB").innerHTML = " ";
    // }

    if (inputA) {
      const body = {
        VentureId: Id,
        VentureName: inputA,
        VentureLogo: file,
        OldLogo:OldLogo
      };
      // console.log(body);

      axios({
        method: "POST",

        url: `${BASE_URL}/Venture/EditVenture`,
        data: body,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + `${token}`,
        },
      })
        .then((response) => {
          console.log(response.data);
          if (response.data.status === "Error") {
            toast.error("InCorrect");
          } else if (response.data.status === "Success") {
            //  toast.success("Venture Updated Successfully!", {
            //    position: "top-center",
            //    autoClose: 3200,
            //    hideProgressBar: false,
            //    closeOnClick: true,
            //    pauseOnHover: true,
            //    draggable: true,
            //    progress: undefined,
            //    className: 'toast-message'
            //    });
            alert("Venture Updated Successfully!");
            setFileA();
            setFile();
            SetEditSaLink();
            //  setTimeout(() => {
            GetVenture();
            closeEditForm();
            //  }, 3000);
          }
        })

        .catch((error) => {
          console.log(error);
          alert("failed !");
        });
    }
  }

  //  //  ActiveStatus

  //  function ActiveStatus(Id,active){

  //   const body ={
  //    id: Id
  //  }

  //   console.log(body)
  //    axios({

  //    method:"POST",
  //   url:`${BASE_URL}/AddUser/ActiveStatus`,
  //   data:body,
  //   headers: {
  //   "Content-Type" : "application/json",

  //   }

  //    })
  //    .then((response) =>{
  //    console.log(response.data);
  //    if(active != 0) {
  //    toast.success("Activated Successfully !", {
  //     position: "top-center",
  //     autoClose: 3200,
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //     progress: undefined,
  //     className: 'toast-message'
  //     });
  //     setTimeout(() => {

  //       Getusers();
  //     }, 1000);
  //    }

  //    else if(active == 0){
  //     toast.success("InActivated Successfully !", {
  //       position: "top-center",
  //       autoClose: 3200,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       className: 'toast-message'
  //       });
  //       setTimeout(() => {

  //         Getusers();
  //       }, 1000);
  //    }

  //    })

  //    }

  //   /*----del btn Onclick func----*/

  //   function  ParoDeleteStatus(Id,UserName){
  //    var ans=window.confirm('Are you sure want to delete this user?');
  //    if(ans==true){const body ={
  //     id: Id
  //   }
  //    console.log('check',body)
  //     axios({

  //     method:"POST",
  //    url:`${BASE_URL}/AddUser/DeleteStatus`,
  //    data:body,
  //    headers: {
  //    "Content-Type" : "application/json",

  //    }

  //     })
  //     .then((response) =>{
  //     console.log(response.data);
  //     toast.success(UserName +" "+"Deleted Successfully !", {
  //      position: "top-center",
  //      autoClose: 3200,
  //      hideProgressBar: false,
  //      closeOnClick: true,
  //      pauseOnHover: true,
  //      draggable: true,
  //      progress: undefined,
  //      className: 'toast-message'
  //      });
  //      setTimeout(() => {

  //        Getusers();
  //      }, 1000);

  //     })}

  //      }

  function DeleteVenture(Id, UserName) {
    var ans = window.confirm("Are you sure want to delete this Venture?");
    if (ans == true) {
      const body = {
        VentureId: Id,
      };

      console.log("check", body);
      axios({
        method: "POST",
        url: `${BASE_URL}/Venture/DeleteVenture`,
        data: body,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + `${token}`,
        },
      }).then((response) => {
        console.log(response.data);
        //  toast.success("Deleted Successfully"+" "+UserName, {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        alert("Deleted Successfully" + " " + UserName);
        setTimeout(() => {
          GetVenture();
        }, 1000);
      });
    }
  }
  function Getusers() {
    console.log("Token", token);
    fetch(`${BASE_URL}/User/GetAllUsers`, {
      method: "GET",

      headers: {
        "Content-type": "application/json",

        Accept: "application/json",

        Authorization: "Bearer " + `${token}`,

        "Access-Control-Allow-Headers": "Access-Control-Request-Headers ",
      },

      //body:JSON.stringify(data)
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Data", data);
        setAllUsers(data);
        //setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      });

    console.log("check", allusers);
  }

  return (
    <>
      <div className="sa-addmain">
        {/*  Toastify */}

        <ToastContainer
          id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <div className="sa-addgrid-layout">
          <div className="sa-addmain-top">
            <div className="sa-addmain-back">
              <Link to="/SuperAdmdashboard">
                <i className="fa-sharp fa-solid fa-backward"></i>
              </Link>
            </div>
            <span>Ventures</span>
          </div>
        </div>

        <div className="sa-addmain-add">
          <button className=" Sa-add-Venture " onClick={Saopenform}>
            {" "}
            <i className="fa-solid fa-user-plus"></i>&nbsp;&nbsp;Add Venture
          </button>
        </div>

        {/* <div className='sa-user'>
      <button className=' Sa-add-Venture '><Link to='/Userview'></Link>  <i className="fa-solid fa-user"></i>&nbsp;&nbsp;User View</button>
    </div> */}

        <div className="sa-user">
          {/* <button className=' Sa-add-Venture ' >  <i className="fa-solid fa-user-plus"></i>&nbsp;&nbsp;Add Venture</button> */}
          <button className=" Sa-add-Venture ">
            <Link to="/Userview" id="userviebutton">
              {" "}
              <i className="fa-solid fa-user"> </i> User View
            </Link>
            &nbsp;{" "}
          </button>
        </div>
        <div
          className="SaVenturepop-fade"
          id="modalRegisterForm"
          tabindex="-1"
          role="dialog"
        >
          <div className="modal-dialog" id="saaddventure" role="document">
            <div className="modal-content">
              <div className="modal-header text-center">
                <h4 className="modal-title w-100 font-weight-bold">
                  ADD VENTURE
                </h4>
                <button type="button" className="close" onClick={SaCloseform}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="modal-body mx-3">
                  {/* <div className="md-form mb-5">
        
                     <input type="text"className="form-control validate"  id="VentureId"  placeholder='Venture ID'onKeyUp={handlechange} />
                     <span id="IdErr" className='error'></span>
                     <span id="IdErrA" className='error'></span>
                    
           </div> */}

                  <div className="md-form mb-5">
                    <input
                      type="text"
                      className="form-control validate"
                      placeholder="Venture Id"
                      id="VentureId"
                      onKeyUp={handlechange}
                    />
                    <span id="nameErri" className="error"></span>
                    <span id="nameErrid" className="error"></span>
                  </div>

                  <div className="md-form mb-5">
                    <input
                      type="text"
                      className="form-control validate"
                      placeholder="Venture Name"
                      id="VentureName"
                      onKeyUp={handlechange}
                    />
                    <span id="nameErr" className="error"></span>
                    <span id="nameErrA" className="error"></span>
                  </div>

                  <div className="md-form mb-5">
                    <input
                      type="file"
                      className="form-control validate"
                      placeholder="Venture Logo"
                      onChange={handleFileChange}
                      id="VentureLogo"
                      onKeyUp={handlechange}
                    />
                    <span id="nameErr1" className="error"></span>
                    <span id="nameErrA" className="error"></span>
                  </div>
                </div>

                <div className="modal-footer d-flex justify-content-center">
                  <button className="sa-adduser-button">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* EditPopup */}

        <div className="Paropop-fade" id="DisplayEditPop">
          {EditParoSection.map((e) => {
            return (
              <div className="modal-dialog" role="document" id="saeditpop">
                <div className="modal-content">
                  <div className="modal-header text-center">
                    <h4 className="modal-title w-100 font-weight-bold">
                      EDIT VENTURE
                    </h4>
                    <button
                      type="button"
                      className="close"
                      onClick={closeEditForm}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <form
                    id="Parosectionform"
                    onSubmit={() => EditVenture(e.ventureId)}
                  >
                    <div className="modal-body mx-3">
                      <div className="md-form mb-5">
                        <label id="ParoSectionTable">Venture Name</label>
                        <input
                          type="text"
                          id="ParotextA"
                          defaultValue={e.ventureName}
                        />
                        <span id="UpdateSecErrA" className="error"></span>
                      </div>

                      <div className="md-form mb-5">
                        <label id="ParoSectionTable">Venture Logo</label>
                        {/* <input type="file" onChange={handleFileChange} /> */}

                        {!file?
         <div><input type="file" style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChange}/>
         <div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px 12px",borderRadius:"2px",marginTop:"-50px"}}>
         <input defaultValue={EditSaLink}  id="OldLogo"style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
          <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
          {/* &nbsp;<span >{e.fileName}</span> */}
          </div>
         </div>:
          <div><form id="sachangeinput"><input type="file" style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChange}/>
          <div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px",borderRadius:"2px",marginTop:"-50px",color:"red"}}>
          <input defaultValue={fileA}  style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
           <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
        
           </div></form> <input defaultValue={e.ventureLogo} id="OldLogo" style={{display:"none"}} /></div>}


                        <span id="UpdateSecErrB" className="error"></span>
                      </div>

                      
                    </div>

                    <div className="modal-footer d-flex justify-content-center">
                      <button className="Paro-adduser-button" type="submit">
                        Update
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            );
          })}
        </div>

        <div className="satable">
          <div className="table_responsive">
            {!paginatedPosts ? (
              "No data found"
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Venture Id</th>
                    <th>Venture Name</th>
                    <th>Venture Logo </th>
                    <th>Venture Actions </th>

                    {/* <th>Logo</th> */}
                  </tr>
                </thead>
                <tbody>
                  {/* mapping to addVenture */}

                  {paginatedPosts.map((venture, index, user) => {
                    return (
                      <tr key={index}>
                        <td>{venture.ventureId1}</td>
                        {/* <td>{user.VentureId}</td> */}
                        <td>{venture.ventureName}</td>
                        {/* <td><img id='VentureImage' src={("https://vignette.wikia.nocookie.net/automobile/images/e/e9/NFS_Most_Wanted_BMW_M3_GTR.jpg/revision/latest?cb=20111118061016")}/></td> */}
                        <td>
                          <img id="VentureImage" src={venture.ventureLogo}/>
                        </td>
                        <td>
                          <i
                            class="fa-solid fa-pen-to-square"
                            id="editicon"
                            onClick={() => selectVenture(venture.ventureId)}
                          ></i>
                          <i
                            class="fa-solid fa-trash"
                            id="deleteicon"
                            onClick={() =>
                              DeleteVenture(
                                venture.ventureId1,
                                venture.ventureName
                              )
                            }
                          ></i>
                        </td>

                        {/* <td> 
             {e.active==1 ?<button id ='ParoActive-buttonA'onClick={()=>ActiveStatus(e.id,e.active)}>Active</button>:
              <button id ='ParoActive-buttonB'onClick={()=>ActiveStatus(e.id,e.active)}>InActive</button>}
               &nbsp;  <button id ='ParoDelete-buttonC' onClick={()=>ParoDeleteStatus(e.id,e.userName)}>Delete</button>
            </td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}

            <br></br>
            <nav>
              <ul className="pagination">
                {pages.map((page) => (
                  <li
                    className={
                      page === currentPage ? "page-item active" : "page-item"
                    }
                  >
                    <p className="page-link" onClick={() => pagination(page)}>
                      {page}
                    </p>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default SaventuresMain;
